/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sessionName: NonNullable<unknown> }} Session_Edit_TitleInputs */

const fr_session_edit_title = /** @type {(inputs: Session_Edit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifier la session : ${i?.sessionName}`)
};

/**

* @param {Session_Edit_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_edit_title = /** @type {((inputs: Session_Edit_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Edit_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_edit_title(inputs)
});